import { IDocumentTable, IDocumentTableApiModel } from '@models/Document.model';
import DocumentTableModel from '@models/DocumentTable.model';
import { IPaginationResult } from '@models/Equipment.model';
import { api } from '@services/api/api';
import { filterEmptyParams } from '@utils/filterEmptyParams';
import { GetDocumentsByStudioParams } from './getDocumentsByStudio.types';
import { makeGetDocumentsByStudioParams } from './makeGetDocumentsByStudioParams';

async function getDocumentsByStudio(
  params: GetDocumentsByStudioParams,
): Promise<IPaginationResult<IDocumentTable>> {
  const { studioId } = params;
  const filteredParams = Object.entries(
    makeGetDocumentsByStudioParams(params),
  ).filter(filterEmptyParams);

  const searchParams = new URLSearchParams(filteredParams);
  const { data } = await api.get<IPaginationResult<IDocumentTableApiModel>>(
    `/documents/${studioId}`,
    {
      params: searchParams,
    },
  );

  return DocumentTableModel.fromArrayPaginatedApiModel(data);
}

export { getDocumentsByStudio };
